<template>
  <div>
    <nav-top @showProfile="showProfile" />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <main class="col-12 custom-main" role="main">
          <slot />
        </main>
      </div>
    </div>
    <hr />
    <pre class="text-right text-muted px-4"> v{{ version }} </pre>
    <user-profile-dialog v-model="actionProfile" @closing="closeModal" @send="savedUserProfile" @sendChangePassword="performChangeProfilePassword" />
    <dialog-password v-model="actionChangePassword" @closing="closeModalPassword" @send="changeProfilePassword" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NavTop from '@/components/navigation/nav-top'
import UserProfileDialog from '@/components/users/forms/user-profile-dialog'
import DialogPassword from '@/components/users/forms/user-password'
export default {
  name: 'layout-default',
  components: {
    NavTop,
    UserProfileDialog,
    DialogPassword
  },
  data() {
    return {
      actionProfile: null,
      actionChangePassword: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    version() {
      let _version = window.version ? window.version : ''
      return _version
    }
  },
  methods: {
    ...mapActions('lookups', ['setLookups']),
    ...mapActions('users', ['getUser', 'saveCredentials']),
    closeModal() {
      this.actionProfile = null
    },
    closeModalPassword() {
      this.actionChangePassword = null
    },
    async showProfile() {
      await this.setLookups({
        keys: [
          'ContactType',
          'Salutation',
          'AddressType',
          'PhoneType',
          'EmailType',
          'StateProvince',
          'Country',
          'RelatedContactType',
          'Language',
          'TimeZone'
        ],
        firm: 1,
        refresh: false
      })
      await this.getUser(this.profile.username)
      let user = {
        firm: this.profile.firm,
        user: this.profile.user,
        contact: this.profile.contact,
        contactType: null,
        username: this.profile.username,
        emailAddress: this.profile.email,
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        roles: this.profile.roles.toString(),
        password: ''
      }
      this.actionProfile = user
    },
    savedUserProfile() {
      this.actionProfile = null
    },
    performChangeProfilePassword() {
      this.actionProfile = null
      let data = {
        firstName: this.profile.firstName,
        lastName: this.profile.lastName,
        user: this.profile.user,
        contact: this.profile.contact,
        username: this.profile.username
      }
      this.actionChangePassword = data
    },
    async changeProfilePassword(data) {
      await this.saveCredentials(data)
      this.actionChangePassword = null
    }
  }
}
</script>
<style lang="scss">
.custom-main {
  padding: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/layouts/default.vue